import SelectCheckMark from '../../../images/selected-checkmark.png';
import './ChoiceQuestion.scss';

export const ChoiceQuestion = ({ question, description, options, onOptionSelect, selectedOption }) => {
  return (
    <div className="choice-question">
      <div className="question">{question}</div>
      <div className="description">{description}</div>
      <div className="options">
        {options.map((option) => (
          <OptionCard
            key={option.key}
            title={option.title}
            image={option.image}
            onSelect={() => {
              if (!Array.isArray(selectedOption)) {
                return onOptionSelect(option.key);
              }

              if (selectedOption.includes(option.key)) {
                return onOptionSelect(selectedOption.filter((selected) => selected !== option.key));
              }

              return onOptionSelect([...selectedOption, option.key]);
            }}
            isSelected={Array.isArray(selectedOption) ? selectedOption.includes(option.key) : selectedOption === option.key}
          />
        ))}
      </div>
    </div>
  );
};

const OptionCard = ({ title, image, onSelect, isSelected }) => {
  return (
    <div className={`option-card ${isSelected ? 'selected' : ''}`} onClick={onSelect}>
      {isSelected && <img src={SelectCheckMark} alt="selected" className="selected-checkmark" />}
      <img src={image} alt={title} />
      <div className="option-title">{title}</div>
    </div>
  );
};
